import configService from './app-config.service';

const vesselLocation = async (authToken, imoNumber) => {
    try {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);

        const options = {
            method: 'GET',
            headers: headers
        };

        imoNumber = imoNumber.replace('/', '');
        const response = await fetch(`${configService.appConfig.apiUrl}/ais/ImoNumber/${imoNumber}`, options);

        if (!response.ok) {
            const message = `An error occurred: ${response.statusText}`;
            console.error(message);
            return;
        }

        const jsonData = await response.json();
        return jsonData;
    } catch (err) {
        return undefined;
    }
};

const AisService = {
    vesselLocation
};

export default AisService;
